// extracted by mini-css-extract-plugin
module.exports = {"Ctatwoo":"Ctatwoo_Ctatwoo__2I9p2"};